module.exports = __webpack_public_path__ + "files/948e0e8c55a42bdb954d683240d33b6c.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/mattermost.png
// module id = 583
// module chunks = 60